<template>
  <div>
  </div>
</template>

<script>
import { getAtbdcqzm } from '@/api/atbdcqzm.js'
import { getSystemConfig } from '@/api/systemConfig.js'
export default {
  filters: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    getSystemConfig({ key: 'BDC_MAP_MOB_URL' }).then(response => {
       console.info(response.data.value)
        window.open(response.data.value)
      })  },
  mounted() { 
  },
};
</script>
<style scoped lang="scss">
</style>